import * as React from "react";
import { Redirect, RouteComponentProps } from "react-router";

export default function Dispositioning(
  _: RouteComponentProps<{ blockId: string }>,
) {
  // AR-11281 removed launch darkly "sentry-dispositioning"
  return <Redirect to="/" />;
}
